import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import { getItem, setItem } from "../../../utils/storageHelper";

// Action Types
export const IMPORT_TIMETABLE_FROM_FILE_SUCCESS = "api/Calendar/importTimetableFromFile/fulfilled";
export const IMPORT_TIMETABLE_FROM_FILE_ERROR = "api/Calendar/importTimetableFromFile/rejected";

// Thunk Action Creator
export const importTimetableFromFile = createAsyncThunk(
    "api/Calendar/importTimetableFromFile",
    async (file, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('file', file, file.name);

            const providerType = await getItem("calendarProvider");

            const response = await axios.post(
                `${import.meta.env.VITE_PUBLIC_DOMAIN}Calendar/import/file/${providerType}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            if (response.status == 200) {
                if (response.data === '') {
                    throw new Error("Problem importing the timetable. Logging the user out");
                } else {
                    const calendarIds = JSON.parse(await getItem("calendar"));

                    let ids = calendarIds;
                    if (!ids.MyTimetable) {
                        ids.MyTimetable = response.data.items[0].extendedProperties.private.calendarId;
                        await setItem("calendar", JSON.stringify(ids));
                    }
                }
            }
            else {
                throw new Error("Error importing timetable");
            }
            // Return the data to be used as the success action's payload
            return response.data;

        } catch (error) {
            // Return a rejected promise with the error message
            return rejectWithValue(error.message);
        }
    }
);